import { forwardRef, ForwardedRef, PropsWithoutRef } from 'react';
import { SelectValueDisplay } from '../SelectValueDisplay';
import { SelectValueDisplayProps } from '../types';

type Props = SelectValueDisplayProps & { categoryIds: { [key: string]: string } };

export const NestedRadioTrigger = forwardRef(
  (
    { categoryIds, selectedOptions = [], ...props }: PropsWithoutRef<Props>,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const hasValue = selectedOptions.length > 0;
    // Since category labels in multiselect do not have labels associated with ids we get the label for the selected id if its a category
    // If the id is in category labels get the index of the label
    const index = hasValue ? Object.values(categoryIds).indexOf(selectedOptions[0].id) : -1;

    // only grab the first one
    const newSelectedOptions = hasValue ? [selectedOptions[0]] : selectedOptions;
    if (index !== -1) {
      // Use the index to get and set the label in the option
      // Since this is only single select we only need to do once
      newSelectedOptions[0].label = Object.keys(categoryIds)[index];
    }

    return (
      <SelectValueDisplay
        selectedOptions={newSelectedOptions}
        ref={ref}
        selectValueDisplayText="Loading..."
        {...props}
      />
    );
  },
);
